import axios from "axios";

const BASE_API_URL = "/web/rest-fp/register-single-vehicle";

export function validateLicensePlate(licensePlate) {
  return axios
    .get(`${BASE_API_URL}/validate/licenseplate/${licensePlate}`)
    .then(result => result.data);
}

export function getProductModel(inputData = {}) {
  return axios
    .post(`${BASE_API_URL}/product-model`, inputData)
    .then(result => result.data);
}

export function finalizeForm(formData) {
  return axios
      .post(`${BASE_API_URL}/finalize`, formData)
      .then(result => result.data);
}
